import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from "react";

export function Button({ className = "", ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button className={`button ${className}`} {...props} />;
}

export function Chip({ children, tone = "plain" }: { children: ReactNode; tone?: "plain" | "safe" | "warn" }) {
  return <span className={`chip chip--${tone}`}>{children}</span>;
}

export function Card({ className = "", ...props }: HTMLAttributes<HTMLElement>) {
  return <article className={`card ${className}`} {...props} />;
}

export function Icon({ name }: { name: "pause" | "cards" | "shield" | "search" | "sound" }) {
  const paths = {
    pause: <path d="M7 5v14M17 5v14" />,
    cards: <path d="M7 5h11v14H7zM4 8H2v12h11v-2" />,
    shield: <path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7zM8.5 12l2.2 2.2 4.8-5" />,
    search: <path d="M11 4a7 7 0 100 14 7 7 0 000-14zm5 12l5 5" />,
    sound: <path d="M4 10v4h4l5 4V6L8 10H4zm13-2c2 2 2 6 0 8" />,
  };
  return <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">{paths[name]}</svg>;
}
